import deepmerge from 'deepmerge';
import isPlainObject from 'is-plain-object';

import getHeaders from '../helpers/get-headers';
import makeColumns from '../helpers/make-columns';
import splitRowsByColumns from '../helpers/split-rows-by-columns';

import fetchData from './fetch-data';
import getTableFromHTML from './get-table-from-html';

const overwriteMerge = (destinationArray, sourceArray) => sourceArray;

class DataProxy {
  constructor() {
    this.data = {
      tables: {
        basic: {
          headers: {},
          content: {},
        },
        weather: {
          headers: {},
          content: {},
        },
        advanced: {
          headers: {},
          content: {},
        },
        local: {
          headers: {},
          content: {},
        },
        global: {
          headers: {},
          content: {},
        },
      },
      initialMode: null,
    };
  }

  prop(key) {
    return this.data[key];
  }

  path(path) {
    return path.reduce((o, k) => (o && o[k] ? o[k] : null), this.data);
  }

  set(path, dataset) {
    const target = path.slice(0, -1).reduce(
      /* eslint-disable-next-line no-return-assign, no-param-reassign */
      (o, k) => (o && o[k] ? o[k] : (o[k] = {})),
      this.data
    );
    target[path[path.length - 1]] = dataset;
  }

  mergeTables(dataset) {
    this.data.tables = deepmerge(this.data.tables, dataset, {
      arrayMerge: overwriteMerge,
      isMergeableObject: isPlainObject,
    });
  }

  fetchAllTables(next) {
    fetchData(this.prop('initialMode')).then(data => {
      Object.keys(data.period_types).forEach(modeName => {
        const basicTable = getTableFromHTML(
          data.period_types[modeName].parts.basic.content
        );

        const heads = Array.from(
          basicTable.querySelectorAll('[data-column-head]')
        );

        const columns = makeColumns(heads);

        Object.keys(data.period_types[modeName].parts).forEach(partName => {
          const { header, content } =
            data.period_types[modeName].parts[partName];

          const tableBody = getTableFromHTML(content);
          const tableHeaders = getTableFromHTML(header);

          this.mergeTables({
            [partName]: {
              nodes: {
                [modeName]: {
                  content: tableBody.tBodies[0] || tableBody.tFoot,
                  headers: tableHeaders.tBodies[0] || tableHeaders.tFoot,
                },
              },
              headers: getHeaders(tableHeaders.rows),
              content: splitRowsByColumns(columns, tableBody.rows, true),
            },
          });
        });
      });

      next(null, this.data.tables);
    });
  }
}

export default DataProxy;
